import { format } from "date-fns";
import {
  convertToDate,
  reformatDateString,
} from "design-system/utils/date-format";
import { EventAgendaItem, EventAgendaItemProps } from "./event-agenda-item";

export interface EventScheduleItemProps {
  date: string; // "YYYY-MM-DD"
  agenda: Array<EventAgendaItemProps>;
}

export function EventScheduleItem(item: EventScheduleItemProps) {
  const date = convertToDate(reformatDateString(item.date));

  return (
    <li className="hbs-event-schedule__list-item">
      {/* Date */}
      {date && (
        <h2 className="hbs-event-schedule__date">
          {format(date, "MMMM")}, {format(date, "yyyy")}{" "}
          <span className="hbs-event-schedule__date-day">
            {format(date, "dd")}
          </span>
        </h2>
      )}

      {/* Schedule */}
      <ul className="hbs-event-schedule__agenda-list">
        {item.agenda.map((slot, i) => (
          <EventAgendaItem key={i} {...slot} />
        ))}
      </ul>
    </li>
  );
}
